export default __webpack_public_path__ + "static/QuestioningSuspects-d4b8bbe26cbb01b83189fafa3aa70cb6.webp";